import { render, staticRenderFns } from "./EmployeeRegistration.vue?vue&type=template&id=52380db6&"
import script from "./EmployeeRegistration.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports